export function getQuickAddCache(store, routePath, key, ttlMs) {
    const cacheStorage = store.state.dashboard.quickAddCache || {};
    const parsed = cacheStorage[key] || null;

    if (parsed && (Date.now() - parsed.cachedAt < ttlMs)) {
        return parsed.items;
    }
    
    if (parsed && (Date.now() - parsed.cachedAt >= ttlMs)) {
        store.commit(`${routePath}/setQuickAddCache`, { key: key, data: null });
    }

    return null;
}

export function setQuickAddCache(store, routePath, key, items) {
    store.commit(`${routePath}/setQuickAddCache`, { key: key, data: { items, cachedAt: Date.now() } });
}
